import { DirectOptionGroupDto, OptionGroupDto, RoomOptionGroupDto } from '@/types';
import { request, generateApiUrl } from '@/utils/ajax';
import { DirectOptionGroupUpdateParams, RoomLinkUpdateParams, RoomOptionGroupUpdateParams } from './option-groups';
import { OptionItemCreateParams } from './option-items';

export interface RoomWizardData {
    optionGroup: RoomOptionGroupUpdateParams;
    optionItems: OptionItemCreateParams[];
    roomLinks: RoomLinkUpdateParams[];
    catalogGroupId?: number;
}

export interface DirectWizardData {
    optionGroup: DirectOptionGroupUpdateParams;
    optionItems: OptionItemCreateParams[];
    linkedResidentialUnitIds: number[];
    catalogGroupId?: number;
}

export function submitRoomWizard(data: RoomWizardData): Promise<RoomOptionGroupDto> {
    return request(`api/option-group/wizard/room`, {
        method: 'POST',
        json: true,
        body: data,
    }).then((x) => x.json());
}

export function submitDirectWizard(data: DirectWizardData): Promise<DirectOptionGroupDto> {
    return request(`api/option-group/wizard/direct`, {
        method: 'POST',
        json: true,
        body: data,
    }).then((x) => x.json());
}
